import * as XLSX from 'xlsx';

export interface ParsedUserRow {
  name: string;
  phone?: string;
  whatsapp?: string;
  email?: string;
  plan_code?: string;
  start_date?: string;
  end_date?: string;
  status?: string;
  row_number?: number;
}

export const parseExcelFile = async (file: File): Promise<ParsedUserRow[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = e.target?.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        
        // Get first sheet
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        
        // Convert to JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { 
          header: 1,
          defval: ''
        }) as any[][];

        if (jsonData.length < 2) {
          reject(new Error('Excel file must contain headers and at least one data row'));
          return;
        }

        // Get headers (first row)
        const headers = jsonData[0].map((h: any) => 
          String(h).toLowerCase().trim()
        );

        // Parse data rows
        const users: ParsedUserRow[] = [];
        for (let i = 1; i < jsonData.length; i++) {
          const row = jsonData[i];
          const user: ParsedUserRow = {
            name: '',
            row_number: i + 1
          };

          headers.forEach((header: string, index: number) => {
            const value = row[index] ? String(row[index]).trim() : '';
            
            switch (header) {
              case 'name':
              case 'નામ':
                user.name = value;
                break;
              case 'phone':
              case 'ફોન':
                user.phone = value;
                break;
              case 'whatsapp':
                user.whatsapp = value;
                break;
              case 'email':
              case 'ઈમેલ':
                user.email = value;
                break;
              case 'plan_code':
              case 'plan':
                user.plan_code = value;
                break;
              case 'start_date':
              case 'start':
                user.start_date = value;
                break;
              case 'end_date':
              case 'end':
                user.end_date = value;
                break;
              case 'status':
                user.status = value;
                break;
            }
          });

          // Only add if name is present
          if (user.name) {
            users.push(user);
          }
        }

        resolve(users);
      } catch (error) {
        reject(new Error(`Failed to parse Excel file: ${error}`));
      }
    };

    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };

    reader.readAsBinaryString(file);
  });
};

export const downloadTemplate = () => {
  const template = [
    ['name', 'phone', 'whatsapp', 'email', 'plan_code', 'start_date', 'end_date', 'status'],
    ['રમેશ પટેલ', '9876543210', '9876543210', 'ramesh@example.com', 'ADMIN_COMP', '2025-01-15', '2026-01-15', 'active'],
    ['સુરેશ શાહ', '9876543211', '', 'suresh@example.com', 'VIP_COMP', '2025-01-15', '2025-12-31', 'active']
  ];

  const ws = XLSX.utils.aoa_to_sheet(template);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Users Template');
  XLSX.writeFile(wb, 'user_import_template.xlsx');
};
